import { useEffect } from 'react';
import { signalR } from 'src/signalR';
import { LOCAL_STORAGE_KEYS } from 'src/utils/constants/localStorageConstants';
import { useLocalStorage } from 'usehooks-ts';
interface UseSignalRProps<T = unknown> {
  methodName: string;
  callback: (data: T) => void;
}

export const useSignalR = <T = unknown,>({ methodName, callback }: UseSignalRProps<T>) => {
  const [, setUnreadNotifications] = useLocalStorage(LOCAL_STORAGE_KEYS.unread_notifications, false);

  useEffect(() => {
    const wrappedCallback = (...args: unknown[]) => {
      callback(args[0] as T);
      setUnreadNotifications(true);
    };

    signalR.addListener(methodName, wrappedCallback);

    return () => {
      signalR.removeListener(methodName, wrappedCallback);
    };
  }, [methodName, callback]);

  return signalR;
};
